import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass({
      'key-stroke': $setup.is_valid,
      'invalid-key-stroke': !$setup.is_valid,
    })
  }, _toDisplayString($setup.keystroke), 3 /* TEXT, CLASS */))
}